import React from 'react'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'

import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'
import { ContentBox, IconList, SimpleItem } from '@offerzen/pinata-shame'

import styles from './styles'

const sections = [
  {
    name: 'parsedSkills',
    label: 'Top skills',
  },
  {
    name: 'parsedPhone',
    label: 'Cellphone number',
  },
  {
    name: 'parsedWorkHistory',
    label: 'Work history',
  },
  {
    name: 'parsedEducation',
    label: 'Education',
  },
  {
    name: 'parsedOnlineProfile',
    label: 'Online profiles',
  },
]

const ImportingResumeSuccess = props => (
  <ContentBox size="default" theme="dark" className={cx(styles.wrapper, props.className)}>
    <p className={styles.text}>
      <span role="alert" aria-live="assertive">
        You&apos;re good to go!
      </span>{' '}
      We&apos;ve filled in the following information for you:
    </p>

    <IconList className={styles.list}>
      <For each="section" of={sections}>
        <If condition={props[section.name]}>
          <SimpleItem key={section.name} className={styles.listItem} icon={CheckCircleIcon} label={section.label} />
        </If>
      </For>
    </IconList>
  </ContentBox>
)

ImportingResumeSuccess.propTypes = {
  className: PropTypes.string,
}

export default ImportingResumeSuccess
